// extracted by mini-css-extract-plugin
export var addButton = "_fr-0";
export var border = "_fr-8";
export var check = "_fr-h";
export var danger = "_fr-6";
export var dropdownContainer = "_fr-1";
export var editModalBody = "_fr-j";
export var footerContainer = "_fr-i";
export var fullWidth = "_fr-a";
export var hide = "_fr-9";
export var icon = "_fr-3";
export var input = "_fr-7";
export var inputFlex = "_fr-b";
export var inputWrapper = "_fr-c";
export var manualFocus = "_fr-5";
export var optionButton = "_fr-4";
export var pillWrapper = "_fr-e";
export var pointer = "_fr-2";
export var showOverflow = "_fr-f";
export var tagsFlex = "_fr-d";
export var xButton = "_fr-g";